import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/imgs/loader.gif'


const _hoisted_1 = {
  key: 0,
  id: "pc-main",
  class: "desktop-view"
}
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "toast-message"
}
const _hoisted_5 = {
  key: 1,
  id: "mobile-view",
  class: "mobile-view"
}
const _hoisted_6 = {
  key: 0,
  class: "loading"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "toast-message"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<audio muted id=\"audio1\"></audio><audio muted id=\"audio2\"></audio><audio muted id=\"audio3\"></audio><audio muted id=\"audio4\"></audio><audio muted id=\"audio5\"></audio><audio muted id=\"audio6\"></audio>", 6)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_numneric_keyboard = _resolveComponent("numneric-keyboard")
  const _component_pop_modal = _resolveComponent("pop-modal")

  return (_openBlock(), _createBlock("div", {
    id: "app",
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.initSound && _ctx.initSound(...args)))
  }, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_Transition, { name: "network-banner" }, {
            default: _withCtx(() => [
              (_ctx.networkBanner)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: ["network-banner", _ctx.networkBanner]
                  }, _toDisplayString(_ctx.networkBannerText), 3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_router_view),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _hoisted_3
              ]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "fadein-out" }, {
            default: _withCtx(() => [
              (_ctx.toastCounter > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("span", null, _toDisplayString(_ctx.toastMessage), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_Transition, { name: "network-banner" }, {
            default: _withCtx(() => [
              (_ctx.networkBanner)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: ["network-banner", _ctx.networkBanner]
                  }, _toDisplayString(_ctx.networkBannerText), 3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_router_view),
          _createVNode(_Transition, { name: "slide-up" }, {
            default: _withCtx(() => [
              (_ctx.showNumericKeyboard)
                ? (_openBlock(), _createBlock(_component_numneric_keyboard, {
                    key: 0,
                    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNumericKeyboard = false)),
                    onConfirm: _ctx.onConfirmNumericKeyboard
                  }, null, 8, ["onConfirm"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "fadein-out" }, {
            default: _withCtx(() => [
              (_ctx.toastCounter > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("span", null, _toDisplayString(_ctx.toastMessage), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])),
    _createVNode(_component_pop_modal, {
      "is-open": _ctx.isPopupOpen,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPopupOpen = false))
    }, null, 8, ["is-open"]),
    _hoisted_9
  ]))
}